<div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs v3-portlet">
  <div class="cards-holder devices-tab">
    <div class="card card1 mRight devices-carousel creative-performance-stats detail-colors">
      <div class="preRoll-creative-completion-stats-container" [hidden]="!hasDaypartData">
        <div class="c-portlet__header o-stack__cell">
          <h5> Time of Day {{timezone}}</h5>
        </div>
        <div class="analytics-portlet-content" style="position: relative; height: 600px">
          <div class="o-stack o-stack--nowrap o-stack--center ht-100">
            <div class="donut-chart-container">
              <div #chartElement id="donut-chart" style="width:100%; height: 100%;">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="no-data-container" *ngIf="!hasDaypartData">
        <app-loader [showLoader]=featureLoad></app-loader>
        <div class="c-portlet__header o-stack__cell">
          <h5> Time of Day {{timezone}}</h5>
        </div>
        <div class="map-no-data" *ngIf="!featureLoad">No Data to Display</div>
      </div>
    </div>
    <div class="card card3 mLeft preroll-creative-v3-carousel-cntr devices-carousel creative-performance-stats display-creative-container">
      <div *ngIf="hasData && displayData">
        <ngu-carousel #carousel [inputs]="carouselOne" (carouselLoad)="initDataFn($event)" (onMove)="onmoveFn($event)"
          [dataSource]="displayData">
          <span NguCarouselPrev class="leftRs">
            <i class="fa fa-angle-left" aria-hidden="true"></i>
          </span>
          <span NguCarouselNext class="rightRs">
            <i class="fa fa-angle-right" aria-hidden="true"></i>
          </span>
          <ngu-tile *nguCarouselDef="let creative; let index = index;" NguCarouselItem>
            <div class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom">
              <div class="o-stack__cell portlet-subheader-wrapper">
                <h5>{{setDisplayProperties.name}}</h5>
                <h6 *ngIf="setDisplayProperties.mp4==''" class="portlet-subheader no-data-portlet-subheader">No Data to
                  Display</h6>
                <h6 *ngIf="setDisplayProperties.mp4 == null" class="portlet-subheader">No Video to Play</h6>
              </div>
            </div>
          </ngu-tile>
          <button NguCarouselPrev class="leftRs">&lt;</button>
          <button NguCarouselNext class="rightRs">&gt;</button>
          <ul class="carousel-points-container myPoint" NguCarouselPoint *ngIf="carousel.pointNumbers && carousel.pointNumbers.length>1">
            <li *ngFor="let j of carousel.pointNumbers; let k = index" [class.active]="j==carousel.activePoint" (click)="carousel.moveTo(k)"></li>
          </ul>
        </ngu-carousel>
        <div class="analytics-portlet-Img100p display-preroll-carousel-height">
          <div class="c-portlet o-block u-width-100p _u-width-100p widget-grid u-shadow-mini u-bg-primary u-color-white-900 c-portlet_box_specs">
            <div class="c-portlet__content u-pt-small">
              <div class="o-stack o-stack center preroll-creative-img" id="videoDisplayblock">
                <div class="video-width">
                  <div class="align-controls">
                    <div class="ShowControls" [hidden]="setDisplayProperties.mp4==''">
                      <video class="" (click)="controlsOptions()" id="preRollvideo" autoplay muted #videoName [src]="setDisplayProperties.mp4">
                        <source type="video/mp4" /> Your browser does not support HTML5 video.
                      </video>
                      <div class="showIconsControls" *ngIf="displayData && displayData.length > 0">
                        <span class="playVideo" (click)="playclickEvent()">
                          <img id="playBtn" class="volumeClass" src="./assets/images/play.png" />
                        </span>
                        <span class="playVideo" (click)="pauseclickEvent()">
                          <img id="pauseBtn" class="volumeClass" src="./assets/images/pause.png" />
                        </span>
                      </div>
                    </div>
                    <div class="volumecontrols">
                      <span id="volumeBtn" class="volumeControlIcon" (click)="volumeclick()">
                        <span class="VolumeControlHoverClass">&nbsp;&nbsp;&nbsp;MUTE&nbsp;&nbsp;&nbsp;</span>
                        <img id="volumebtn" class="volumeClass" src="./assets/images/muteicon.png" />
                      </span>
                      <span id="muteBtn" class="volumeControlIcon" (click)="muteclick()">
                        <!--<i class="volumecontrols fa fa-volume-off"></i>-->
                        <span class="VolumeControlHoverClass">UNMUTE</span>
                        <img id="mutebtn" class="volumeClass" src="./assets/images/unmuteicon.png" />
                      </span>
                    </div>
                  </div>
                  <div>
                    <div>
                      <ul class="preRoll-creative-stats creative-stats">
                        <li>
                          <span class="stats preRoll-creative-header-content">{{setDisplayProperties.impressions|formatNumber}}</span>
                          <span class="stats-label preRoll-creative-views ">IMPRESSIONS</span>
                        </li>
                        <li>
                          <span class="stats preRoll-creative-header-content">{{setDisplayProperties.percent_value_100
                            | formatNumber}}</span>
                          <span class="stats-label preRoll-creative-views ">COMPLETIONS</span>
                        </li>
                        <li class= "ctv-creative-header">
                          <span class="stats preRoll-creative-header-content">{{setDisplayProperties.completion_rate |
                            formatNumber}}%</span>
                          <span class="stats-label preRoll-creative-views ">COMPLETION RATE</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="ctv-impressions">
                  <div class="table-header_label" *ngIf="displayData && displayData.length > 0">
                    <div (click)="circleVideoClickEvent(0)" class="preroll-creative-table_svg_content">
                      <div id="percent0" class="creative_text_mask">
                        <div class="preRoll-creative-header-content add-color">Started</div>
                        <div class="preRoll-creative-views">{{setDisplayProperties.impressions|formatNumber}} Views</div>
                      </div>
                      <div class="c100 small p100">
                        <div id="creative_mask_0" class="creative_mask"></div>
                        <span class="add-color">100%</span>
                        <div class="slice">
                          <div class="bar"></div>
                          <div class="primary-color-border fill"></div>
                        </div>
                      </div>
                    </div>
                    <div class="preroll-creative-table_svg_content">
                      <div (click)="circleVideoClickEvent(25)" class="preroll-creative-progress-50">
                        <div id="percent25" class="creative_text_mask">
                          <div class="preRoll-creative-header-content">25% Completed</div>
                          <div class="preRoll-creative-views">{{setDisplayProperties.percent_value_25|formatNumber}}
                            Views</div>
                        </div>
                        <div class="c100 small" [ngClass]="getPercentageClass(setDisplayProperties.percent_rate_25)">
                          <div id="creative_mask_25" class="creative_mask"></div>
                          <span>{{setDisplayProperties.percent_rate_25}}%</span>
                          <div class="slice">
                            <div class="bar"></div>
                            <div class="primary-color-border fill"></div>
                          </div>
                        </div>
                      </div>
                      <div (click)="circleVideoClickEvent(50)" class="preroll-creative-progress-50">
                        <div id="percent50" class="creative_text_mask">
                          <div class="preRoll-creative-header-content">50% Completed</div>
                          <div class="preRoll-creative-views">{{setDisplayProperties.percent_value_50|formatNumber}}
                            Views</div>
                        </div>
                        <div class="c100 small" [ngClass]="getPercentageClass(setDisplayProperties.percent_rate_50)">
                          <div id="creative_mask_50" class="creative_mask"></div>
                          <span>{{setDisplayProperties.percent_rate_50}}%</span>
                          <div class="slice">
                            <div class="bar"></div>
                            <div class="primary-color-border fill"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="preroll-creative-table_svg_content">
                      <div (click)="circleVideoClickEvent(75)" class="preroll-creative-progress-50">
                        <div id="percent75" class="creative_text_mask">
                          <div class="preRoll-creative-header-content">75% Completed</div>
                          <div class="preRoll-creative-views">{{setDisplayProperties.percent_value_75|formatNumber}}
                            Views</div>
                        </div>
                        <div class="c100 small" [ngClass]="getPercentageClass(setDisplayProperties.percent_rate_75)">
                          <div id="creative_mask_75" class="creative_mask"></div>
                          <span>{{setDisplayProperties.percent_rate_75}}%</span>
                          <div class="slice">
                            <div class="bar"></div>
                            <div class="primary-color-border fill"></div>
                          </div>
                        </div>
                      </div>
                      <div (click)="circleVideoClickEvent(100)" class="preroll-creative-progress-50">
                        <div id="percent100" class="creative_text_mask">
                          <div class="preRoll-creative-header-content">100% Completed</div>
                          <div class="preRoll-creative-views">{{setDisplayProperties.percent_value_100|formatNumber}}
                            Views</div>
                        </div>
                        <div class="c100 small" [ngClass]="getPercentageClass(setDisplayProperties.percent_rate_100)">
                          <div id="creative_mask_100" class="creative_mask"></div>
                          <span>{{setDisplayProperties.percent_rate_100}}%</span>
                          <div class="slice">
                            <div class="bar"></div>
                            <div class="primary-color-border fill"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <span class="datatable-icon creative-download-icon" *ngIf="downloadConfiguration && downloadConfiguration.enableDownload">
          <a class="datatable_download_icon" href="javascript:void(0)" target="_blank" (click)="downloadCSV($event)">
            <i aria-hidden="true" class="fa fa-download"></i>
          </a>
        </span>
      </div>
      <div class="no-data-container" *ngIf="!hasData">
          <app-loader [showLoader]=showLoad></app-loader>
          <div class="map-no-data" *ngIf="!showLoad">No Data to Display</div>
      </div>
      <!-- </div> -->
    </div>
  </div>
</div>